import { gql } from "@apollo/client";
import { skipToken, useQuery, useSuspenseQuery } from "@apollo/client/react";

import BIMClass from "./BIMClass.graphql";
import { taxonomy } from "../../modules/api";

export function useSuspenseBIMClass(id: string) {
    return useSuspenseQuery(
        gql(BIMClass),
        id
            ? {
                client: taxonomy,
                variables: {
                    id,
                },
            }
            : skipToken,
    );
}

export default function useBIMClass(id: string) {
    return useQuery(
        gql(BIMClass),
        {
            client: taxonomy,
            skip: id === undefined,
            variables: {
                id,
            },
        },
    );
}
